module.exports = {
    'CookieContainsPattern': require('./cookie-contains-pattern'),
    'HasAcceptedFunctional': require('./has-accepted-functional'),
    'HasAcceptedPerformance': require('./has-accepted-performance'),
    'HasAcceptedStrictlyNecessary': require('./has-accepted-strictly-necessary'),
    'HasAcceptedTargeting': require('./has-accepted-targeting')
};